import withFocusedBoothId from "modules/booths/higher-order-components/withFocusedBoothId";
import Button from "modules/Core/sub-modules/ui-kit/components/Button";
import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import cells from "modules/cycles/state";
import { getDefaultCycleFlow } from "modules/cycles/consts";

export default withFocusedBoothId(strappedConnected(
    Button,
    {},
    { create: cells.createCycle.action },
    ({ create, boothId, callback }) => ({
        text: "init iteration",
        onClick: () => create({
            input: { boothId, activateCycle: true, flow: getDefaultCycleFlow() },
            callback,
        })
    })
))